/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-shadow */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  ReactAux, InfoCard, Section, LoanRequestBox
} from '@jkhy/vsg-design-system';

import { Base, BaseType as BaseType_ } from '../common/base-component';

import LINKS from '../../utils/links';
import { AppState as AppState_ } from '../../redux/app-state';
import { CountingModel as CountingModel_, QDEnabledModel as QDEnabledModel_ } from '../../redux/actions/counts-qd-enabled-actions';
import PublicContent from '../../data/models/PublicContent';
import '../../../css/default.css';

type HomeProps = {
  reqDocsFetched: CountingModel_,
  qdCommercialModelsFetched: CountingModel_,
  qdConsumerModelsFetched: CountingModel_,
  isQDEnabled: QDEnabledModel_,
} & BaseType_

export const PageDataUI = 'Home';

export class Home extends Base<HomeProps, {}> {
  redirectTo = (url: string) => this.props.history.push(url);

  content = () => {
    const {
      reqDocsFetched,
      qdCommercialModelsFetched,
      qdConsumerModelsFetched,
    } = this.props;

    const {
      homePageTitle, homePageDescription,
      externalApplicationPageTitle, newCommercialRequestDescription, newCommercialRequestHyperlinkText,
      newConsumerRequestPageTitle, newConsumerRequestDescription, newConsumerRequestHyperlinkText,
    } = window?.PublicContent ?? new PublicContent();

    return (
      <ReactAux>
        <Section dataUI={PageDataUI}>
          <h1 data-ui={`${PageDataUI}-page-title`} className="mb-2 text-preline break-word">{homePageTitle}</h1>
          <p data-ui={`${PageDataUI}-page-description`} className="mb-3 text-preline break-word">{homePageDescription}</p>

          {reqDocsFetched.count > 0
            && (
              <InfoCard
                className="mb-3"
                titles={['Requested Documents']}
                description={`You have ${reqDocsFetched.count} requested ${reqDocsFetched.count > 1 ? 'documents' : 'document'}`}
                link={{ label: 'DETAILS', path: LINKS.REQUIRED, dataUI: 'HomeRequestedDocumentsCardLink', }}
                dataUI="HomeRequestedDocumentsCard"
              />
            )}

          {this.props.isQDEnabled.isEnabled
            && (
              <ReactAux>
                {qdCommercialModelsFetched.count > 0
                  && (
                    <LoanRequestBox
                      requestType="commercial"
                      title={externalApplicationPageTitle}
                      description={newCommercialRequestDescription}
                      cta={newCommercialRequestHyperlinkText}
                      onButtonClick={() => this.redirectTo(LINKS.NEW_COMMERCIAL_REQUEST)}
                      dataUI="home-create-loan-request"
                      className="mb-3 text-preline break-word"
                    />
                  )}
                {qdConsumerModelsFetched.count > 0
                  && (
                    <LoanRequestBox
                      requestType="consumer"
                      title={newConsumerRequestPageTitle}
                      description={newConsumerRequestDescription}
                      cta={newConsumerRequestHyperlinkText}
                      onButtonClick={() => this.redirectTo(LINKS.NEW_CONSUMER_REQUEST)}
                      dataUI="home-create-consumer-loan-request"
                      className="text-preline break-word"
                    />
                  )}
              </ReactAux>
            )}
        </Section>
      </ReactAux>
    );
  }
}

export default withRouter(connect(
  (state: AppState_) => ({
    reqDocsFetched: state.reqDocsFetched,
    isQDEnabled: state.isQDEnabled,
    qdCommercialModelsFetched: state.qdExternalCommercialModelsFetched,
    qdConsumerModelsFetched: state.qdExternalConsumerModelsFetched,
  })
)(Home));
